export const StringHelpers = () => {
    
    const IsAlphaNumeric = (str) => {
        var code, i, len;

        for (i = 0, len = str.length; i < len; i++) {
            code = str.charCodeAt(i);
            if (
                !(code > 47 && code < 58) && // numeric (0-9)
                !(code > 64 && code < 91) && // upper alpha (A-Z)
                !(code > 96 && code < 123)
            ) {
                // lower alpha (a-z)
                return false;
            }
        }
        return true;
    }
    const RemoveBlanks = (input) => {
        return input.replace(/\s+/g, '');
    }

    return {
        IsAlphaNumeric,
        RemoveBlanks
    }
}

// Export standalone functions for backward compatibility
export const isAlphaNumeric = (str) => {
    var code, i, len;

    for (i = 0, len = str.length; i < len; i++) {
        code = str.charCodeAt(i);
        if (
            !(code > 47 && code < 58) && // numeric (0-9)
            !(code > 64 && code < 91) && // upper alpha (A-Z)
            !(code > 96 && code < 123)
        ) {
            // lower alpha (a-z)
            return false;
        }
    }
    return true;
}

//check if a string contains letters 
export const containsLetters = (str) => {
    return /[a-zA-Z]/.test(str);
}

export const removeBlanks = (input) => {
    return input.replace(/\s+/g, '');
}

//Normalizza una descrizione per il confronto: rimuove accenti, porta in minuscolo e
//converte la punteggiatura in spazi singoli.
//Serve ogni volta che si confronta un testo scritto su Workspace (in maiuscolo e senza
//punteggiatura) con la forma ufficiale presente nelle tabelle base: i toponimi
//(es. "CHALLAND SAINT ANSELME" contro "Challand-Saint-Anselme" di base_comune) e le
//descrizioni dei tipi documento (es. "CARTA D'IDENTITA" contro "Carta d'identità").
export const normalizeLabel = (input) => {
    if (!input) return "";
    return input
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, " ")
        .trim();
}

//Alias storico usato dai resolver degli indirizzi.
export const normalizeToponym = (input) => normalizeLabel(input);
